'use client'

import useI18n from 'Hooks/useI18n'
import { CodeBlock, ScrollableBlock } from './GuideShared'
import GuideModalShell from './GuideModalShell'

type OpeningGuideModalProps = {
  open: boolean
  onClose: () => void
}

function Page1() {
  const { t } = useI18n()

  const exampleCode = t('opening_guide_example_code')

  return (
    <div>
      <h2 className="text-xl font-semibold text-white">
        {t('opening_guide_page1_title')}
      </h2>
      <div className="mt-4 space-y-3 text-sm leading-6 text-white/70">
        <p>{t('opening_guide_three_tags_intro')}</p>
        <p>
          <span className="font-semibold text-white">{'<message>'}</span> —{' '}
          {t('opening_guide_message_tag_desc')}
        </p>
        <p className="pl-4 text-white/50">
          {t('opening_guide_message_tag_hint')}
        </p>
        <p>
          <span className="font-semibold text-white">{'<narration>'}</span> —{' '}
          {t('opening_guide_narration_tag_desc')}
        </p>
        <p className="pl-4 text-white/50">
          {t('opening_guide_narration_tag_hint')}
        </p>
        <p>
          <span className="font-semibold text-white">{'<html-box>'}</span> —{' '}
          {t('opening_guide_htmlbox_tag_desc')}
        </p>
        <p className="pl-4 text-white/50">
          {t('opening_guide_htmlbox_tag_hint')}
        </p>
        <p className="text-white/70">{t('Example structure:')}</p>
      </div>
      <div className="mt-3">
        <CodeBlock code={exampleCode} />
      </div>
    </div>
  )
}

function Page2() {
  const { t } = useI18n()

  const quoteExample = t('opening_guide_quote_example')

  return (
    <div>
      <h2 className="text-xl font-semibold text-white">
        {t('opening_guide_page2_title')}
      </h2>
      <div className="mt-4 space-y-3 text-sm leading-6 text-white/70">
        <p>{t('opening_guide_page2_intro')}</p>

        <p className="font-semibold text-white">
          {t('opening_guide_replace1_title')}
        </p>
        <p>{t('opening_guide_replace1_desc')}</p>
      </div>
      <div className="mt-3">
        <CodeBlock code={quoteExample} />
      </div>
      <div className="mt-4 space-y-3 text-sm leading-6 text-white/70">
        <p className="font-semibold text-white">
          {t('opening_guide_replace2_title')}
        </p>
        <p>{t('opening_guide_replace2_desc')}</p>
        <blockquote className="mt-2 border-l-2 border-white/30 pl-3 text-white/50">
          {t('opening_guide_replace_effect')}
        </blockquote>
      </div>
    </div>
  )
}

function Page3() {
  const { t } = useI18n()

  const prompt = t('opening_guide_ai_prompt')

  return (
    <div>
      <h2 className="text-xl font-semibold text-white">
        {t('opening_guide_page3_title')}
      </h2>
      <div className="mt-4 text-sm leading-6 text-white/70">
        <p>{t('opening_guide_page3_intro')}</p>
      </div>
      <div className="mt-3">
        <ScrollableBlock text={prompt} />
      </div>
      <div className="mt-3 text-sm text-white/50">
        {t(
          'Tip: Replace the character information above with your own character settings.'
        )}
      </div>
    </div>
  )
}

function Page4() {
  const { t } = useI18n()

  const tips = `1. ${t('Please center the character name')}
2. ${t('Please make text sections more distinct')}
3. ${t('opening_guide_tip_pink_elements')}
4. ${t('opening_guide_tip_remove_course')}
5. ${t('opening_guide_tip_locked_section')}
6. ${t('opening_guide_tip_horizontal_swipe')}`

  return (
    <div>
      <h2 className="text-xl font-semibold text-white">
        {t('Advanced Requirements Reference (Official Tips)')}
      </h2>
      <div className="mt-4 text-sm leading-6 text-white/70">
        <p>{t('opening_guide_page4_intro')}</p>
      </div>
      <div className="mt-3">
        <ScrollableBlock text={tips} />
      </div>
    </div>
  )
}

const PAGES = [Page1, Page2, Page3, Page4]

export default function OpeningGuideModal({
  open,
  onClose,
}: OpeningGuideModalProps) {
  return <GuideModalShell open={open} onClose={onClose} pages={PAGES} />
}
